import { SVGProps } from "react";

const UploadIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24, stroke = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5274_3297)">
        <mask
          id="mask0_5274_3297"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M8 16V24H0V0H24V24H16V16H8Z" fill="white" />
        </mask>
        <g mask="url(#mask0_5274_3297)">
          <path
            d="M15.6637 8.95554L15.4387 8.39932L15.6637 8.95554C16.23 8.72644 16.8495 8.6 17.5 8.6C20.2062 8.6 22.4 10.7938 22.4 13.5C22.4 16.2062 20.2062 18.4 17.5 18.4H13H8.5C4.68924 18.4 1.6 15.3108 1.6 11.5C1.6 7.68924 4.68924 4.6 8.5 4.6C11.2739 4.6 13.6668 6.23689 14.763 8.60005C14.9209 8.94053 15.3178 9.09546 15.6637 8.95554Z"
            stroke={stroke}
            strokeWidth="1.2"
          />
        </g>
        <path
          d="M12 15L12 23"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="square"
        />
        <path d="M9 15L12 12L15 15L9 15Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_5274_3297">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UploadIcon;
